import React from "react";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import * as styles from './contactHero.module.css';

function ContactHero(props) {
    
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

  return (
    <div className={styles.sectionContactHero} style={{ backgroundColor: `${bgColor}`}}>
        <div className={styles.sectionContainer}>
            <h1>{props.heading}</h1>
            <div className={styles.contentWrap}>
                <PortableText blocks={props.content} />
            </div>
        </div>
        <div className={styles.bgCircle}>
            <img src={require('../images/hero_circle.png').default} alt="Download in Google Play" />
        </div>
    </div>
  );
}

export default ContactHero;
